import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RoutesPaths } from "../Router/constant";

export default function Header({ onToggleAside }) {
  const location = useLocation();
  const [isBreadCrumb, setIsBreadCrumb] = useState("");
  const [isBreadCrumbSecond, setIsBreadCrumbSecond] = useState("");
  const removeParams = (route) => route.replace(/:\w+/g, "");

  useEffect(() => {
    const path = location.pathname;

    const EDIT_STORE_BASE = removeParams(RoutesPaths.EDITSTORS);
    const VIEW_STORE_BASE = removeParams(RoutesPaths.VIEWSTORS);
    const EDIT_CATEGORY_BASE = removeParams(RoutesPaths.EDITCATEGORIES);
    const EDIT_BANNER_BASE = removeParams(RoutesPaths.EDITBANNER);
    const EDIT_PROMOTIONAL_BANNER_BASE = removeParams(
      RoutesPaths.EDITPROMOTIONALBANNER
    );

    if (path === RoutesPaths.DASHBOARD) {
      setIsBreadCrumb("dashboard");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.USERS) {
      setIsBreadCrumb("users");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.CATEGORIES) {
      setIsBreadCrumb("category");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.ADDCATEGORIES) {
      setIsBreadCrumb("category");
      setIsBreadCrumbSecond("add-category");
    } else if (path.startsWith(EDIT_CATEGORY_BASE)) {
      setIsBreadCrumb("category");
      setIsBreadCrumbSecond("edit-category");
    } else if (path === RoutesPaths.BANNER) {
      setIsBreadCrumb("banner");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.ADDBANNER) {
      setIsBreadCrumb("banner");
      setIsBreadCrumbSecond("add-banner");
    } else if (path.startsWith(EDIT_BANNER_BASE)) {
      setIsBreadCrumb("banner");
      setIsBreadCrumbSecond("edit-banner");
    } else if (path === RoutesPaths.PROMOTIONALBANNER) {
      setIsBreadCrumb("promotional-banner");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.ADDPROMOTIONALBANNER) {
      setIsBreadCrumb("promotional-banner");
      setIsBreadCrumbSecond("add-banner");
    } else if (path.startsWith(EDIT_PROMOTIONAL_BANNER_BASE)) {
      setIsBreadCrumb("promotional-banner");
      setIsBreadCrumbSecond("edit-banner");
    } else if (path === RoutesPaths.STORS) {
      setIsBreadCrumb("stores");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.ADDSTORS) {
      setIsBreadCrumb("store");
      setIsBreadCrumbSecond("add-store");
    } else if (path.startsWith(EDIT_STORE_BASE)) {
      setIsBreadCrumb("store");
      setIsBreadCrumbSecond("edit-store");
    } else if (path.startsWith(VIEW_STORE_BASE)) {
      setIsBreadCrumb("store");
      setIsBreadCrumbSecond("view-store");
    } else if (path === RoutesPaths.CHATS) {
      setIsBreadCrumb("chats");
      setIsBreadCrumbSecond("");
    } else if (path === RoutesPaths.PROFILE) {
      setIsBreadCrumb("profile");
      setIsBreadCrumbSecond("");
    } else {
      setIsBreadCrumb("");
      setIsBreadCrumbSecond("");
    }
  }, [location.pathname]);

  return (
    <div>
      <div className="header align-items-stretch">
        <div className="header-brand">
          <Link to={RoutesPaths.DASHBOARD}>
            <img
              alt="Logo"
              src="/assets/media/logos/miaxaLogo.svg"
              className="h-75px h-lg-75px"
            />
          </Link>

          <div
            className="d-flex align-items-center d-lg-none me-n2"
            title="Show aside menu"
          >
            <div
              className="btn btn-icon btn-active-color-primary w-30px h-30px"
              onClick={onToggleAside}
            >
              <i className="ki-duotone ki-abstract-14 fs-1">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div>
          </div>
        </div>

        <div className="toolbar d-flex align-items-stretch">
          <div className="container-fluid py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between">
            <div className="page-title d-flex justify-content-center flex-column me-5">
              <h1 className="d-flex flex-column text-gray-900 fw-bold fs-3 mb-0">
                Dashboard
              </h1>

              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 pt-1">
                <li className="breadcrumb-item text-muted">
                  <Link
                    to={RoutesPaths.DASHBOARD}
                    className="text-muted text-hover-primary"
                  >
                    Home
                  </Link>
                </li>

                {isBreadCrumb && (
                  <>
                    <li className="breadcrumb-item">
                      <span className="bullet bg-gray-300 w-5px h-2px"></span>
                    </li>
                    <li className="breadcrumb-item text-muted">
                      {isBreadCrumb}
                    </li>
                  </>
                )}

                {isBreadCrumbSecond && (
                  <>
                    <li className="breadcrumb-item">
                      <span className="bullet bg-gray-300 w-5px h-2px"></span>
                    </li>
                    <li className="breadcrumb-item text-muted">
                      {isBreadCrumbSecond}
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
